/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonUserBaseFromJSON, InternalCommonUserBaseToJSON, } from './InternalCommonUserBase';
/**
 * @export
 */
export const InternalUserPostResponseV3TypeEnum = {
    Post: 'post'
};
/**
 * Check if a given object implements the InternalUserPostResponseV3 interface.
 */
export function instanceOfInternalUserPostResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    return true;
}
export function InternalUserPostResponseV3FromJSON(json) {
    return InternalUserPostResponseV3FromJSONTyped(json, false);
}
export function InternalUserPostResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'title': json['title'],
        'contentHtml': json['content_html'] == null ? undefined : json['content_html'],
        'user': json['user'] == null ? undefined : InternalCommonUserBaseFromJSON(json['user']),
    };
}
export function InternalUserPostResponseV3ToJSON(json) {
    return InternalUserPostResponseV3ToJSONTyped(json, false);
}
export function InternalUserPostResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'title': value['title'],
        'content_html': value['contentHtml'],
        'user': InternalCommonUserBaseToJSON(value['user']),
    };
}
